module.exports = __webpack_public_path__ + "img/syncio_logo_full.3215283d.svg";